export const urlConfiguration = {
  baseUrl: process.env.REACT_APP_URL,
  TIMEOUT: 300000,
  urlEndpoints: {},
};
